/**
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited  2023.
 */

import { Button, styled } from '@mui/material';
import { FC } from 'react';

const StyledButton = styled(Button)`
	${({}) => `
    /* Estilo personalizado para el estado 'disabled' */
    &.Mui-disabled {
      opacity: 1;
      cursor: pointer !important;
    }
  font-weight: normal;
  border: 1px solid #C9C9C9;
    background: #FFFFFF 0% 0% no-repeat padding-box;
    color: #2C2C2C !important;
  cursor: pointer !important;
  border-radius: 0px;
  min-width: 68px;
  max-height: 43px;
`}
`;

type Props = {
	active: string;
	size: string;
	onClick: () => void;
};

export const ProductAttributeV2Button: FC<Props> = ({ active, size, onClick }) => (
	<StyledButton
		sx={
			active === size
				? {
						backgroundColor: '#E8F3FF',
						color: '#007EFF',
						border: '1px solid #0080F7',
						borderRadius: '2px 0px 0px 0px',
				  }
				: { cursor: 'pointer !important' }
		}
		onClick={onClick}
	>
		{size}
	</StyledButton>
);
